import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sales-support-page',
  templateUrl: './sales-support-page.component.html',
  styleUrls: ['./sales-support-page.component.scss']
})
export class SalesSupportPageComponent implements OnInit{

  public content:any = 1;

  constructor(
    private route: ActivatedRoute
  ){
    
    let params:any = this.route.params;
    this.content   = params['_value'].id || null;

  
  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit(): void {
    
  }

}
